@file:OptIn(ExperimentalUuidApi::class)

package dev.moetz.sslcertificatetool.http

import dev.moetz.sslcertificatetool.serializer.UuidAsStringSerializer
import kotlinx.serialization.Serializable
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

@Serializable
data class SubmitDomainResponseBody(
    @Serializable(with = UuidAsStringSerializer::class)
    val id: Uuid,
)
